import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_ALL_QUALIFICATIONS = restRequest(
    "VRCORE_QUALIFICATIONS_MANAGER.GET_ALL_QUALIFICATIONS"
);
export const SET_QUALIFICATION_TO_SELECTED = restRequest(
    "VRCORE_QUALIFICATIONS_MANAGER.SET_QUALIFICATION_TO_SELECTED"
);
export const SET_QUALIFICATION_TO_DESELECTED = restRequest(
    "VRCORE_QUALIFICATIONS_MANAGER.SET_QUALIFICATION_TO_DESELECTED"
);
export const SET_SNACKBAR_STATE = "VRCORE_QUALIFICATIONS_MANAGER.SET_SNACKBAR_STATE";
export const SET_QUAL_SELECTED_TABLE_PAGE =
    "VRCORE_QUALIFICATIONS_MANAGER.SET_QUAL_SELECTED_TABLE_PAGE";
export const SET_QUAL_AVAILABLE_TABLE_PAGE =
    "VRCORE_QUALIFICATIONS_MANAGER.SET_QUAL_AVAILABLE_TABLE_PAGE";
export const SET_QUAL_AVAILABLE_TABLE_ROW =
    "VRCORE_QUALIFICATIONS_MANAGER.SET_QUAL_AVAILABLE_TABLE_ROW";
export const SET_QUAL_SELECTED_TABLE_ROW =
    "VRCORE_QUALIFICATION_MANAGER.SET_QUAL_SELECTED_TABLE_ROW";
export const SET_QUAL_EDIT_MODAL_INFO = "VRCORE_QUALIFICATION_MANAGER.SET_QUAL_EDIT_MODAL_INFO";
export const POST_QUAL_EDIT_INFO = restRequest("VRCORE_QUALIFICATION_MANAGER.POST_QUAL_EDIT_INFO");
export const GET_QUALIFICATION_CATEGORIES = restRequest(
    "VRCORE_QUALIFICATIONS_MANAGER.GET_QUALIFICATION_CATEGORIES"
);
export const SET_QUALS_AVAILABLE_SELECTED_CATEGORY =
    "VRCORE_QUALIFICATIONS_MANAGER.SET_QUALS_AVAILABLE_SELECTED_CATEGORY";
export const SET_ADD_MODAL_INFO = "VRCORE_QUALIFICATIONS_MANAGER.SET_ADD_MODAL_INFO";
export const GET_ALL_USERS = restRequest("VRCORE_QUALIFICATIONS_MANAGER.GET_ALL_USERS");
export const GET_LIST_OF_REQUIRED_QUALIFICATIONS = restRequest(
    "VRCORE_QUALIFICATIONS_MANAGER.GET_LIST_OF_REQUIRED_QUALIFICATIONS"
);
export const POST_REQUIRED_QUALIFICATION = restRequest(
    "VRCORE_QUALIFICATIONS_MANAGER.POST_REQUIRED_QUALIFICATION"
);
export const POST_UPDATED_USERS = restRequest("VRCORE_QUALIFICATIONS_MANAGER.POST_UPDATED_USERS");
export const SET_DELETE_MODAL_INFO = "VRCORE_QUALIFICATIONS_MANAGER.SET_DELETE_MODAL_INFO";
export const DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS = restRequest(
    "VRCORE_QUALIFICATIONS_MANAGER.DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS"
);
export const DELETE_QUALIFICATION_FROM_USERS = restRequest(
    "VRCORE_QUALIFICATIONS_MANAGER.DELETE_QUALIFICATION_FROM_USERS"
);

export const SET_QUALS_SELECTED_CATEGORY =
    "VRCORE_QUALIFICATIONS_MANAGER.SET__QUALS_SELECTED_CATEGORY";
